<template>
  <default-layout>
    <div :id="ID_JSS_LAYOUT_DEFAULT" class="outer">
      <!-- TODO: This div should be a main but in order to do that we need to remove all the other mains -->
      <div
        class="page"
        ref="page"
        tabindex="-1"
      >
        <slot>
          <nuxt />
        </slot>
      </div>
      <critical-error-modal />
    </div>
  </default-layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { ID_JSS_LAYOUT_DEFAULT } from '~/constants/integration'
import DefaultLayout from '~/layouts/default'
import CriticalErrorModal from '~/components/critical-error-modal'
import Theme from '~/constants/theme'

const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  authenticated: false,
  middleware: [
    'fetchUser',
    'initializer'
  ],

  components: {
    DefaultLayout,
    CriticalErrorModal
  },

  head () {
    return {
      bodyAttrs: {
        class: this.bodyClass
      }
    }
  },

  data () {
    return {
      ID_JSS_LAYOUT_DEFAULT
    }
  },

  computed: {
    ...mapEnvGetters(['themeColor']),

    // TODO components should not be using this to style it should be removed
    bodyClass () {
      return `theme-${this.themeColor === Theme.Dark ? 'black' : 'white'}`
    }
  }
}
</script>
